export default "__VITE_ASSET__fxqXArCj__"